import React from 'react';
import styles from '../styles/flippercard.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCss3Alt,  faHtml5, faJs, faNode, faPython } from '@fortawesome/free-brands-svg-icons';

const FlipperCard = ({ index, image, text, link, skills }) => {
    const skillToIconMap = {
        "CSS3": <FontAwesomeIcon icon={faCss3Alt} />,
        "HTML5": <FontAwesomeIcon icon={faHtml5} />,
        "JavaScript": <FontAwesomeIcon icon={faJs} />,
        "Express.js": <FontAwesomeIcon icon={faNode} />,
        "Python": <FontAwesomeIcon icon={faPython} />,
      };

    return (
            <div className={styles.card}>
                <div className={styles.cover} style={{backgroundImage: `url(${image})`}}>
                <h1>{text.title}</h1>
                <div className={styles.brandContainer}>
                {skills.filter(skill => skill in skillToIconMap)
                    .map((skill, index) => (
                    <React.Fragment key={index}>{skillToIconMap[skill]}</React.Fragment>
                ))}
                </div>

                <div className={styles.description}>
                    <p>{text.description}</p>
                </div>

                <div className={styles.cardBack}>
                    <a href={link} target="_blank" rel="noopener noreferrer">View Code</a>
                </div>
                </div>
            </div>
    )
};
  
export default FlipperCard;